/**
 * 省市区数据加载器
 * 优先使用静态数据，提升加载速度
 */

import axios from 'axios'

// 缓存数据
let areaCache = {
  provinces: null,
  cities: {},
  districts: {}
}

/**
 * 获取省份列表
 */
export async function getProvinces() {
  if (areaCache.provinces) {
    return areaCache.provinces
  }
  
  try {
    const response = await axios.get('/api/area/provinces')
    if (response.data && response.data.code === 200) {
      areaCache.provinces = response.data.data || []
      return areaCache.provinces
    }
  } catch (error) {
    console.error('加载省份数据失败:', error)
  }
  return []
}

/**
 * 获取城市列表
 */
export async function getCities(provinceId) {
  if (!provinceId) return []
  
  const cacheKey = String(provinceId)
  if (areaCache.cities[cacheKey]) {
    return areaCache.cities[cacheKey]
  }
  
  try {
    const response = await axios.get('/api/area/cities', { params: { provinceId } })
    if (response.data && response.data.code === 200) {
      areaCache.cities[cacheKey] = response.data.data || []
      return areaCache.cities[cacheKey]
    }
  } catch (error) {
    console.error('加载城市数据失败:', error)
  }
  return []
}

/**
 * 获取区县列表
 */
export async function getDistricts(cityId) {
  if (!cityId) return []
  
  const cacheKey = String(cityId)
  if (areaCache.districts[cacheKey]) {
    return areaCache.districts[cacheKey]
  }
  
  try {
    const response = await axios.get('/api/area/districts', { params: { cityId } })
    if (response.data && response.data.code === 200) {
      areaCache.districts[cacheKey] = response.data.data || []
      return areaCache.districts[cacheKey]
    }
  } catch (error) {
    console.error('加载区县数据失败:', error)
  }
  return []
}

/**
 * 清除缓存
 */
export function clearAreaCache() {
  areaCache = {
    provinces: null,
    cities: {},
    districts: {}
  }
}
